import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUbisoftComponent } from './simple-icons-ubisoft.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUbisoftComponent ],
    exports:      [ SimpleIconsUbisoftComponent ],
    bootstrap:    []
})
export class SimpleIconsUbisoftModule {}
